export enum TIP_PERMISSIONS {
  TIP_VIEW = 'TIP_VIEW',
  TIP_WRITE = 'TIP_WRITE',
}
